import { useState } from "react";
import type { LocationData } from "../../../mocks/locationData";

interface LocationFAQProps {
  location: LocationData;
  onBookNow: () => void;
}

export default function LocationFAQ({ location, onBookNow }: LocationFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-white py-20 px-6 lg:px-10">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-14">
          {/* Left: FAQs */}
          <div className="flex-1">
            <p className="text-xs font-black text-cl-green uppercase tracking-widest mb-2">FAQs</p>
            <h2 className="text-3xl md:text-4xl font-black text-cl-dark leading-tight mb-8">
              {location.city} Rubbish Removal — <span className="text-cl-green">Common Questions</span>
            </h2>

            <div className="flex flex-col gap-3">
              {location.faqs.map((faq, i) => (
                <div
                  key={i}
                  className="bg-cl-tint rounded-2xl thick-border cartoon-shadow overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-cl-dark font-black text-sm">{faq.question}</span>
                    <span
                      className={`w-7 h-7 flex items-center justify-center rounded-lg flex-shrink-0 transition-all ${
                        openIndex === i ? "bg-cl-green text-white rotate-45" : "bg-cl-lime text-cl-dark"
                      } border-2 border-cl-dark`}
                    >
                      <i className="ri-add-line text-sm font-black"></i>
                    </span>
                  </button>
                  {openIndex === i && (
                    <div className="px-5 pb-5">
                      <p className="text-gray-500 text-sm font-semibold leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right: contact card */}
          <div className="w-full lg:w-80 flex-shrink-0">
            <div className="bg-cl-dark rounded-2xl p-7 thick-border cartoon-shadow sticky top-24">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-cl-lime border-2 border-cl-green mb-5">
                <i className="ri-customer-service-2-line text-cl-dark text-xl"></i>
              </div>
              <h3 className="text-white font-black text-lg mb-2">Still got questions?</h3>
              <p className="text-white/60 text-sm font-semibold mb-6 leading-relaxed">
                Our {location.city} team is available 7 days a week — just give us a ring or book online.
              </p>
              <div className="flex flex-col gap-3">
                <a
                  href="tel:03335775445"
                  className="flex items-center justify-center gap-2 bg-cl-lime text-cl-dark font-black px-5 py-3 rounded-xl text-sm whitespace-nowrap cartoon-btn"
                >
                  <i className="ri-phone-fill text-sm"></i>
                  03335 775445
                </a>
                <button
                  onClick={onBookNow}
                  className="bg-cl-green text-white font-black px-5 py-3 rounded-xl text-sm cartoon-btn-green whitespace-nowrap"
                >
                  Book Online — Fixed Price
                </button>
              </div>
              <div className="mt-6 pt-5 border-t border-white/10">
                <div className="flex gap-0.5 mb-1">
                  {[...Array(5)].map((_, i2) => (
                    <i key={i2} className="ri-star-fill text-[#00b67a] text-sm"></i>
                  ))}
                </div>
                <p className="text-white font-black text-sm">Excellent · 4.8 / 5</p>
                <p className="text-white/40 text-xs mt-0.5 font-semibold">36,690 Trustpilot reviews</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
